import { TextField, TextFieldProps } from '@mui/material';
import IncFormHelperText from 'components/forms/inc-form-helper-text/inc-form-helper-text.component';
import { Controller } from 'react-hook-form';
import { mergeRefs } from 'util/merge-refs';
import { IncField } from '../fields.types';
import { MaskInput } from './mask-field.component';

export type IncTextFieldMaskedProps = IncField<TextFieldProps> & {
  mask: string;
  placeholder: string;
  definitions: any;
};

export const IncTextFieldMasked = ({
  name,
  helperText,
  IncFormHelperTextProps,
  inputRef,
  defaultValue,
  mask,
  placeholder,
  definitions,
  ...rest
}: IncTextFieldMaskedProps) => {
  return (
    <Controller
      name={name}
      defaultValue={defaultValue}
      render={({
        field: { ref: rhfRef, ...fieldRest },
        fieldState: { error },
      }) => (
        <TextField
          {...fieldRest}
          inputRef={mergeRefs([rhfRef, inputRef])}
          error={!!error}
          helperText={
            <IncFormHelperText
              error={error}
              helperText={helperText}
              {...IncFormHelperTextProps}
            />
          }
          InputProps={{
            inputComponent: MaskInput as any,
            inputProps: {
              mask,
              placeholder,
              definitions,
            },
          }}
          {...rest}
        />
      )}
    />
  );
};

export default IncTextFieldMasked;
